import { useSyncExternalStore } from 'react';

// Breakpoints match Bootstrap's: mobile is under md (768px), tablet is md up to xl (1200px)
export const MOBILE_QUERY = '(max-width: 767.98px)';
export const BELOW_DESKTOP_QUERY = '(max-width: 1199.98px)';

/**
 * Whether a CSS media query currently matches, updating when the viewport crosses it.
 * For layout differences that CSS alone cannot express, such as a chart's pixel height.
 */
export const useMediaQuery = (query) =>
  useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
